import { driver } from "driver.js";

export const disciplineListGuide = () => {
  return driver({
    showProgress: true,
    steps: [
      {
        popover: {
          title: "👋 Let's get started...",
          description:
            "This tour will guide you through all sections and components in this discipline list.",
        },
      },
      {
        element: "#discipline_list_createbtn",
        popover: {
          title: "Create New Discipline",
          description: "Click this button to create a new discipline.",
        },
      },
      {
        element: "#discipline_list_searchby",
        popover: {
          title: "Search Field",
          description: "Use this dropdown to search.",
        },
      },
      {
        element: "#discipline_list_searchbytext",
        popover: {
          title: "Enter Your Value",
          description:
            "When selecting a previous dropdown value, enter your desired search value.",
        },
      },
      {
        element: "#discipline_list_searchbtn",
        popover: {
          title: "Search",
          description:
            "After selecting a previous dropdown or entering a value, click this button to get results.",
        },
      },
      {
        element: "#discipline_list_table",
        popover: {
          title: "Discipline Table",
          description:
            "Table displaying discipline details where you can edit and delete disciplines.",
        },
      },
      {
        element: "#discipline_list_edit",
        popover: {
          title: "Edit Discipline",
          description: "Click this button to edit the discipline.",
        },
      },
      {
        element: "#discipline_list_delete",
        popover: {
          title: "Delete Discipline",
          description: "Click this button to delete the discipline.",
        },
      },
      {
        popover: {
          title: "Congratulations 🎉",
          description: "Now you can create disciplines.",
        },
      },
    ],
  });
};

export const createDisciplineGuide = () => {
  return driver({
    showProgress: true,
    steps: [
      {
        popover: {
          title: "👋 Let's get started...",
          description:
            "This tour will guide you through all sections and components in creating or editing a discipline.",
        },
      },
      {
        element: "#discipline_create_discipline",
        popover: {
          title: "Select Discipline",
          description: "Select discipline using the dropdown.",
        },
      },
      {
        element: "#discipline_create_keyname",
        popover: {
          title: "Key Name",
          description: "Select the key name using the dropdown.",
        },
      },
      {
        element: "#discipline_create_docno",
        popover: {
          title: "Document Number",
          description: "Enter the document number.",
        },
      },
      {
        element: "#discipline_create_master_issueno",
        popover: {
          title: "Issue Number",
          description: "Enter the issue number.",
        },
      },
      {
        element: "#discipline_create_issuedate",
        popover: {
          title: "Issue Date",
          description: "Select the issue date.",
        },
      },
      {
        element: "#discipline_create_amendnumber",
        popover: {
          title: "Amendment Number",
          description: "Enter the amendment number.",
        },
      },
      {
        element: "#discipline_create_ammenddate",
        popover: {
          title: "Amendment Date",
          description: "Select the amendment date.",
        },
      },
      {
        element: "#discipline_create_remarks",
        popover: {
          title: "Remarks",
          description: "Enter remarks.",
        },
      },
      {
        element: "#discipline_create_save",
        popover: {
          title: "Save Discipline",
          description: "Click this button to save the discipline.",
        },
      },
      {
        popover: {
          title: "Congratulations 🎉",
          description: "Now you can create/edit a discipline.",
        },
      },
    ],
  });
};
